import { StoreState } from '../index';
import { isFrench } from '../../helpers/language.helper';

export const blockingSelector = (state: StoreState) => isFrench() ? state.assortment.blockingAttributesInfo.blockingFr : state.assortment.blockingAttributesInfo.blocking;
export const blockingAttributesSelector = (state: StoreState) => state.blockingAttributesFilter;
